module.exports = __webpack_public_path__ + "images/common/twitter.65b8c11d.svg";